var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('v-progress-circular',{staticClass:"progress-spinner",attrs:{"size":40,"indeterminate":"","color":"primary"}}):_c('v-file-input',{staticClass:"file-input",attrs:{"dark":"","prepend-icon":"mdi-plus","hide-input":""},on:{"change":_vm.addFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }